<template>
  <div class="tendency-wrap">
    <div class="tendency-search">
      <input
        v-model="search"
        type="text"
        @keyup.enter="searchHandle"
        placeholder="请输入品牌名或关键词搜索"
      />
      <span
        class="pointer"
        @click="searchHandle"
      ><i class="icon-search"></i> 搜索</span>
    </div>
    <div class="tendency-content">
      <div class="tendency-left">
        <div
          class="tendency-article"
          v-loading="loading"
          element-loading-text="加载中"
        >
          <news-item
            v-for="item in newsList"
            :key="item"
            :detail="item"
            title="商业洞察列表"
            :search='search'
          ></news-item>
          <div
            class="no-data"
            v-if="newsList.length===0 && loading===false"
          >
            <P class="no-list-data"></P>
            <p class="no-news-text">抱歉，没有找到相关的资讯！</p>
            <div class="no-news-list">
              <p>建议您：</p>
              <p>1、请检查您输入的关键词是否有错误；</p>
              <p>2、换另一个相似的词，或常见的词试试；</p>
            </div>
          </div>
        </div>
        <div class="w-page-sty">
          <el-pagination
            background
            v-if="total>12"
            layout="prev, pager, next"
            :current-page="pageNum"
            @current-change="pageHandle"
            :page-size="pageSize"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="tendency-right">
        <hot-focus class="mb-20"></hot-focus>
        <brand-top class="mb-20"></brand-top>
        <brand-tab></brand-tab>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import brandTop from './brandTop.vue'
import newsItem from './newsItem.vue'
import brandTab from './brandTab'
import hotFocus from './hotFocus'
export default {
  data () {
    return {
      search: '',
      newsList: [],
      loading: true,
      pageNum: 1,
      pageSize: 12,
      total: 0
    }
  },
  components: {
    brandTop,
    newsItem,
    brandTab,
    hotFocus
  },
  created () {
    this.search = this.$route.query.search || ''
    this.getSearchList()
  },
  methods: {
    //
    pageHandle (val) {
      this.pageNum = val
      this.getSearchList(true)
    },
    toDetail () {
      const brandTendencyDetail = this.$router.resolve({
        path: '/brandTendencyDetail',
        query: {
          title: encodeURIComponent('商业洞察列表')
        }
      })
      window.open('/' + brandTendencyDetail.href, '_blank')
    },
    // 更多资讯
    toList () {
      const page = this.$router.resolve({
        path: '/brandTendencyList',
        query: {
        }
      })
      window.open('/' + page.href, '_blank')
    },
    getSearchList (flag) {
      this.loading = true
      this.axios.post(api.getNewsBrandNewsSearch, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        category: '',
        keyWord: this.search
      })
        .then((res) => {
          this.loading = false
          if (res.data.code === 0) {
            if (flag) {
              document.documentElement.scrollTop = 0
            }
            this.newsList = res.data.data.newsListVos
            this.total = res.data.data.newsAmount
          }
        })
    },
    // 搜索
    searchHandle () {
      if (!this.search) {
        this.$message({
          type: 'warning',
          message: '请输入你要搜索的关键词！',
          duration: 3000
        })
      } else {
        this.pageNum = 1
        this.getSearchList()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.mb-20
  margin-bottom 20px
.tendency-wrap
  margin 0 auto
  width 1280px
  color #ffffff
.tendency-content
  display flex
  .tendency-left
    width 808px
    margin-right 23px
  .tendency-right
    width 450px
.tendency-search
  margin-top 25px
  margin-bottom 25px
  display flex
  input
    line-height 40px
    height 40px
    background rgba(39, 41, 48, 1)
    border 1px solid transparent
    outline none
    color #ffffff
    font-size 14px
    padding 0 21px
    flex 1
  span
    color #ffffff
    font-size 14px
    width 113px
    background rgba(62, 62, 69, 1)
    display inline-block
    line-height 40px
    height 40px
    text-align center
    i
      font-size 17px
      margin-right 6px
      margin-left -18px
      vertical-align middle
      color #ffffff
      &:before
        content '\E741'
        color #ffffff
.tendency-article
  background-color #272930
  border-radius 2px
.tendency-title
  position relative
  font-size 18px
  color #fff
  font-weight 500
  margin-left 20px
  padding-left 10px
  margin-bottom 20px
  i
    position absolute
    left 0
    top 3px
    width 2px
    height 18px
    background #ffa134
.see-more
  font-size 15px
  line-height 60px
  text-align center
  color #999
  span
    cursor pointer
.no-news-list
  color #cecece
  font-size 14px
  text-align left
  margin-left 300px
  width 264px
  line-height 30px
.no-news-text
  color #fff
  font-size 16px
  line-height 40px
.w-page-sty
  margin-bottom 20px
  text-align center
</style>
